<template>
  <div class="tabsVue">
    <div>
      <!-- <MainFilters
        :users='users'
        :events='events'
      /> -->
    </div>
    <div>
      <v-tabs color="primary accent-4" left>
        <v-tab
          v-for="calendar in calendarChoice"
          :key="calendar"
          @click="getDataCalendarSelected(calendar)"
          >{{ calendar }}</v-tab
        >

        <v-tab-item vertical v-for="calendar in calendarChoice" :key="calendar">
          <v-container fluid>
            <v-row>
              <GridScheduler
                :users="users"
                :events="events"
                :calendarSelected="calendarSelected"
              />
            </v-row>
          </v-container>
        </v-tab-item>
      </v-tabs>
    </div>
  </div>
</template>

<script>
import GridScheduler from "@/components/components-planning/public/calendar/grid-scheduler/GridScheduler.vue";
import MainFilters from "@/components/components-planning/public/calendar/filters/MainFilters.vue";

export default {
  name: "Tabs",
  components: {
    GridScheduler,
    MainFilters,
  },
  data() {
    return {
      tab: null,
      calendarChoice: [],
    };
  },
  mounted() {},
  methods: {
    getDataCalendarSelected(calendar) {
      
    },
  },
};
</script>

<style lang="scss">
.tabsVue {
  display: flex;
  flex-direction: column;
}
</style>
